import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { formatEther } from 'viem'
import { formatFormAmount } from '~/utils/numbers'
import { RequestStatusClaimable } from './types'
import styled from 'styled-components'
import IconChecked from '~/assets/images/checked.svg'

interface RequestReadyItemProps {
  request: RequestStatusClaimable
  isSelected?: boolean
  onSelect?: (selected: boolean) => void
}

const RequestReadyItem: React.FC<RequestReadyItemProps> = ({
  request,
  isSelected = false,
  onSelect,
}) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(isSelected)

  const handleSelect = () => {
    const newSelected = !selected
    setSelected(newSelected)
    onSelect?.(newSelected)
  }

  const formattedAmount = formatFormAmount(formatEther(request.claimableEth))

  return (
    <StyledRequestItem selected={selected} onClick={handleSelect}>
      <StyledCheckboxContainer>
        <StyledCheckbox selected={selected}>
          {selected && <StyledChecked src={IconChecked} alt="checked" />}
        </StyledCheckbox>
        <StyledAmount>{formattedAmount} ETH</StyledAmount>
      </StyledCheckboxContainer>
      <StyledStatus>{t('claim_status_ready')}</StyledStatus>
    </StyledRequestItem>
  )
}

const StyledRequestItem = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 63px;
  padding: 16px 12px;
  border: 0.5px solid
    ${({ selected, theme }) =>
      selected ? theme.colors.primary : theme.colors.borderSubtle};
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  margin-bottom: 8px;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:last-child {
    margin-bottom: 0;
  }
`

const StyledCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledCheckbox = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.colors.primary : theme.colors.borderSubtle};
  border-radius: 50%;
  background: ${({ selected, theme }) =>
    selected ? theme.colors.primary : '#ffffff'};
  transition: all 0.2s ease;
`

const StyledChecked = styled.img`
  width: 16px;
  height: 16px;
`

const StyledAmount = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textTitle};
`

const StyledStatus = styled.div`
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.colors.statusSuccess};
  border-radius: 20px;
  color: ${({ theme }) => theme.colors.statusSuccess};
  background: ${({ theme }) => theme.colors.statusSuccessBg};
  font-size: 13px;
  font-weight: 500;
`

export default RequestReadyItem
